export default function($stateProvider) {
  'ngInject';

  $stateProvider.state('myAccount', {
    component: 'fizyPaycellMyAccount',
    parent: 'mainWrapper',
    url: '/?buySuccess',
    params:{'from': null}
  });
}



// WEBPACK FOOTER //
// ./src/app/my-account/my-account.routes.ts